import moment from 'moment';

function getFormattedDeliveryDateRange(baseDateStr: string, isSpaced: boolean): string {
  if (!baseDateStr) return '';

  const normalizedDateStr = baseDateStr.replace(/\./g, '-');

  const baseDate = moment(normalizedDateStr, 'YYYY-MM-DD', true);
  if (!baseDate.isValid()) return '';

  const startDate = baseDate.clone()
    .subtract(1, 'days');
  const endDate = baseDate.clone()
    .add(3, 'days');

  const format = (date: moment.Moment) => date.format('MM.DD');
  return (isSpaced ? `${format(startDate)} \u2014 ${format(endDate)}` : `${format(startDate)}–${format(endDate)}`);
}

function getFormattedDeliveryDateRangeText(baseDateStr: string, isSpaced: boolean): string {
  if (!baseDateStr) return '';

  const normalizedDateStr = baseDateStr.replace(/\./g, '-');

  const baseDate = moment(normalizedDateStr, 'YYYY-MM-DD', true);
  if (!baseDate.isValid()) return '';

  const startDate = baseDate.clone()
    .subtract(1, 'days');
  const endDate = baseDate.clone()
    .add(3, 'days');

  const format = (date: moment.Moment) => date.format('MMM D');
  return (isSpaced ? `${format(startDate)} \u2014 ${format(endDate)}` : `${format(startDate)} to ${format(endDate)}`);
}

export {
  getFormattedDeliveryDateRange, getFormattedDeliveryDateRangeText,
};
